import { createTheme } from "@mui/material/styles";
import { green, blue } from "@mui/material/colors";

export const basicTheme = createTheme({
  palette: {
    primary: blue,
  },
});
